import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import './OrderForm.css';
import OrderFormRows from './OrderFormRows';

function isValidIcelandicNationalId(id: string) {
  if (!id) return false;
  if (typeof id !== "string") return false;
  if (id.length !== 10) return false;

  var sum = 0;
  var weight = [3, 2, 7, 6, 5, 4, 3, 2];

  for (var i = 0; i < weight.length; i++) {
    sum += weight[i] * parseInt(id.charAt(i));
  }

  var checkDigit = (11 - (sum % 11)) % 11;
  if (checkDigit === 10) checkDigit = 0;

  return id.charAt(8) === checkDigit.toString();
}

declare global {
  interface Window {
    products: any;
  }
}

function OrderForm() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [products, setProducts] = useState(window.products)
  const [loading, setLoading] = useState(false);

  return (
    <div id="torfOrderFormContainer">

      {showSuccess ? (
        <div>
          Takk fyrir pöntunina. Við munum hafa samband við fyrsta tækifæri. <br/>
          <br/>
          Akstur innan höfuðborgarsvæðisins er innifalinn ef magnið er yfir 100fm. Sé það undir 100fm er akstursgjaldið kr. 28.000 óháð magni. Akstur utan höfuðborgarsvæðisins og til suðurnesja er samningsatriði.
        </div>
      ) : (
        <>
          <div id="orderFormContent" className="pb-4">
            Hér er verðlisti yfir helstu torfgerðir í boði. <br/>
            <br/>
            Akstur innan höfuðborgarsvæðisins er innifalinn ef magnið er yfir 100fm. Sé það undir 100fm er akstursgjaldið kr. 28.000 óháð magni. Akstur utan höfuðborgarsvæðisins og til suðurnesja er samningsatriði.
          </div>

          <Formik
            initialValues={{
              customerDeliveryPickUp: false,
              differentShippingAddress: false,
              email: '',
              nationalId: '',
              phone: '',
              firstName: '',
              lastName: '',
              address: '',
              zipCode: '',
              city: '',
              shippingAddress: '',
              shippingZipCode: '',
              shippingCity: '',
              products: products,
              message: '',
            }}
            validate={values => {
              const errors: any = {};

              // Email or Phone
              if (!values.email && !values.phone) {
                errors.email = 'Nauðsynlegt';
                errors.phone = 'Nauðsynlegt';
              } else if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = 'Ógilt netfang';
              } else if (values.phone && !/^\d{3}(-)?\d{4}$/.test(values.phone)) {
                errors.phone = 'Ógilt símanúmer'
              }

              // National Id
              if (!values.nationalId) {
                errors.nationalId = 'Nauðsynlegt';
              } else if (!isValidIcelandicNationalId(values.nationalId)) {
                errors.nationalId = 'Ógilt kt.';
              }
              // First Name
              if (!values.firstName) {
                errors.firstName = 'Nauðsynlegt';
              }
              // Last Name
              if (!values.lastName) {
                errors.lastName = 'Nauðsynlegt';
              }
              // Address
              if (!values.address) {
                errors.address = 'Nauðsynlegt';
              }
              // Zip Code
              if (!values.zipCode) {
                errors.zipCode = 'Nauðsynlegt';
              } else if (!/^\d{3}$/.test(values.zipCode)) {
                errors.zipCode = 'Ógilt póstnúmer';
              }
              // City
              if (!values.city) {
                errors.city = 'Nauðsynlegt';
              }
              // Shipping Address
              if (values.differentShippingAddress && !values.shippingAddress) {
                errors.shippingAddress = 'Nauðsynlegt';
              }
              // Shipping Zip Code
              if (values.differentShippingAddress && !values.shippingZipCode) {
                errors.shippingZipCode = 'Nauðsynlegt';
              } else if (values.differentShippingAddress && !/^\d{3}$/.test(values.shippingZipCode)) {
                errors.shippingZipCode = 'Ógilt póstnúmer';
              }
              // Shipping City
              if (values.differentShippingAddress && !values.shippingCity) {
                errors.shippingCity = 'Nauðsynlegt';
              }

              return errors;
            }}
            onSubmit={(values: any, { setSubmitting }) => {
              setTimeout(() => {
                setLoading(true);
                // Remove all product with quantity 0
                values.products = values.products.filter((product: any) => product.quantity > 0);

                const form = new FormData();
                form.append("action", "torf_order_form_action");
                form.append("form", JSON.stringify(values));
                const params = new URLSearchParams(form as any);

                fetch('/wp-admin/admin-ajax.php', {
                  method: 'POST',
                  body: params,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                  },
                  mode: 'cors',
                  cache: 'no-cache',
                  credentials: 'same-origin',
                  redirect: 'follow',
                  referrerPolicy: 'no-referrer',
                })
                  .then(response => response.json())
                  .then(data => {
                    setSubmitting(false);
                    setShowSuccess(true);
                    setLoading(false);
                  })
                  .catch(error => {
                    // Tell the user there was an error
                    setLoading(false);
                  });

              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>

                {/* Customer Pick Up */}
                <label htmlFor="apCustomerPickUp">
                  <input
                    id="apCustomerPickUp"
                    type="checkbox"
                    name="customerDeliveryPickUp"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <span className="font-bold uppercase ml-2">Ef torfið er sótt á ræktunarstað, (Borgareyrar, 861 Hvolsvelli) þá lækkar fm verðið um kr. 100.</span>
                </label>

                {/* Order Form */}
                <OrderFormRows products={values.products} customerDeliveryPickUp={values.customerDeliveryPickUp} />

                {/* Billing Information */}
                <div className="pt-4">
                  <div>
                    <div className="flex mb-2">
                      <div className="pr-4">
                        <h2><b>Kaupandi:</b></h2>
                      </div>
                      <div className="grow mr-2">
                        <input
                          id="contactNationalId"
                          type="text"
                          placeholder="Kt."
                          inputMode='numeric'
                          name="nationalId"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.nationalId}
                          className={`border ${errors.nationalId && touched.nationalId ? "border-red-500" : ""}`}
                        />
                      </div>
                      <div className="grow max-width-200">
                        <input
                          id="contactPhone"
                          type="tel"
                          inputMode='numeric'
                          placeholder="Simi"
                          name="phone"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                          className={`border ${errors.phone && touched.phone ? "border-red-500" : ""}`}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <input
                          id="contactFirstName"
                          type="text"
                          placeholder="Fornafn"
                          name="firstName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.firstName}
                          className={`border ${errors.firstName && touched.firstName ? "border-red-500" : ""}`}
                        />
                      </div>
                      <div>
                        <input
                          id="contactLastName"
                          type="text"
                          placeholder="Eftirnafn"
                          name="lastName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastName}
                          className={`border ${errors.lastName && touched.lastName ? "border-red-500" : ""}`}
                        />
                      </div>
                      <div>
                        <input
                          id="contactAddress"
                          type="text"
                          placeholder="Götuheiti"
                          name="address"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          className={`border ${errors.address && touched.address ? "border-red-500" : ""}`}
                        />
                      </div>
                      <div>
                        <input
                          id="contactCity"
                          type="text"
                          placeholder="Bæjarfélag"
                          name="city"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.city}
                          className={`border ${errors.city && touched.city ? "border-red-500" : ""}`}
                        />
                      </div>
                      <div>
                        <input
                          id="contactZipCode"
                          type="text"
                          placeholder="Póstnúmer"
                          name="zipCode"
                          inputMode='numeric'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.zipCode}
                          className={`border ${errors.zipCode && touched.zipCode ? "border-red-500" : ""}`}
                        />
                      </div>
                      <div>
                        <input
                          id="contactEmail"
                          type="email"
                          placeholder="Netfang"
                          name="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          className={`border ${errors.email && touched.email ? "border-red-500" : ""}`}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Shipping Information */}
                  <div className="py-4">
                    <label htmlFor="apShippingAddressAsBilling">
                      <input
                        id="apShippingAddressAsBilling"
                        className="mr-2"
                        type="checkbox"
                        name="differentShippingAddress"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <span><b>Vara óskast afhent á öðru heimilisfangi sem er:</b></span>
                    </label>

                    {values.differentShippingAddress ? (
                      <div className="grid grid-cols-2 gap-2 py-4">
                        <div>
                          <input
                            id="contactShippingAddress"
                            type="text"
                            placeholder="Götuheiti"
                            name="shippingAddress"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.shippingAddress}
                            className={`border ${errors.shippingAddress && touched.shippingAddress ? "border-red-500" : ""}`}
                          />
                        </div>
                        <div>
                          <input
                            id="contactShippingCity"
                            type="text"
                            placeholder="Bæjarfélag"
                            name="shippingCity"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.shippingCity}
                            className={`border ${errors.shippingCity && touched.shippingCity ? "border-red-500" : ""}`}
                          />
                        </div>
                        <div>
                          <input
                            id="contactShippingZipCode"
                            type="text"
                            placeholder="Póstnúmer"
                            name="shippingZipCode"
                            inputMode='numeric'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.shippingZipCode}
                            className={`border ${errors.shippingZipCode && touched.shippingZipCode ? "border-red-500" : ""}`}
                          />
                        </div>
                      </div>
                    ) : null}

                  </div>

                  <div>
                    <div>
                      <textarea className="" rows={4} placeholder="Skilabod" name="message" value={values.message} onChange={handleChange}></textarea>
                    </div>
                  </div>
                </div>

                <div className="torf-errors hidden"></div>
                <div className="torf-order-form-submit mt-4">
                  {loading ? (
                    <button type="submit" className="submit px-8 py-4 text-center align-center flex rounded-xl" disabled>
                      <svg className="animate-spin h-5 w-5 mr-3 bg-white rounded-sm" viewBox="0 0 24 24">
                      </svg>
                      Í vinnslu...
                    </button>
                  ) : (
                    <input className="submit" type="submit" value="PANTA" onChange={handleChange} />
                  )}
                </div>
              </form>
            )}
          </Formik>
        </>
      )}

    </div >
  );
}

export default OrderForm;
